import ReusableDialog, {
	IReusableDialogFooterProps,
} from '../../controls/ReusableDialog';
import { Dropdown, IDropdownOption, Stack, StackItem, TextField } from '@fluentui/react';
import { observer } from 'mobx-react';
import { EntityTypesState } from './EntityTypes';
import { FieldType, ProvisionType } from '../../../API';
import { InfoTooltipLabel } from '../../controls/InfoTooltipLabel';
import FieldPicker from '../../controls/FieldPicker';

function EntityTypeCreateNewDialog({
	state
}: {
	state: EntityTypesState;
}) {
	const provisionTypeOptions: IDropdownOption[] = [
			{
				key: ProvisionType.Site,
				text: 'SharePoint Site',
			},
			{
				key: ProvisionType.Library,
				text: 'Document Library',
			},
			{
				key: ProvisionType.Folder,
				text: 'Folder',
			},
			{
				key: ProvisionType.Team,
				text: 'Microsoft Team',
			},
			{
				key: ProvisionType.TeamChannel,
				text: 'Microsoft Team Channel',
			},
			{
				key: ProvisionType.NoWorkspace,
				text: 'Don\'t create a workspace',
			},
		];
	
	let isValidConfig:boolean = !!(state.newEntityTypeListUrl && state.newEntityTypeSingularName && state.newEntityTypePluralName);

	if(isValidConfig && state.newEntityTypeProvisionType !== ProvisionType.NoWorkspace && !state.newEntityUrlStorageField) {
		//If no URL is selected, don't allow them to continue
		isValidConfig = false;
	}

	const deleteFooterProps: IReusableDialogFooterProps = {
		leftButtons: [{
			text: 'Cancel',
			onClick: (ev) => {
				state.newEntityTypeDialog.setVisible(false);
			},
		}],
		rightButtons: [{
			text: 'Create new connection',
			disabled: !isValidConfig,
			onClick: (ev) => {
				state.addNewEntityType();
			},
		}],
	};

	return (
		<>
			<ReusableDialog state={state.newEntityTypeDialog} footerButtons={deleteFooterProps}>

				<InfoTooltipLabel label='SharePoint List URL' title='URL to the SharePoint list that you will use to store configuration for your workspaces.'>
					<TextField onChange={(_,v) => { state.setNewEntityTypeListUrl(v || '') }} />
				</InfoTooltipLabel>
				
				<InfoTooltipLabel label='What type of workspace do you want to provision?' title='Select the type of workspace to provision. This can be further configured later.'>
					<Dropdown
						options={provisionTypeOptions}
						selectedKey={state.newEntityTypeProvisionType}
						onChange={(_, o) => { state.setNewEntityTypeProvisionType(o?.key as ProvisionType); }}
					/>
				</InfoTooltipLabel>
				
				<Stack horizontal>
					<StackItem>
						
						<InfoTooltipLabel label='Singular Name' title='This will be the naming convention used throughout the app to refer to a single instance of this entity type.'>
							<TextField placeholder='e.g. Workspace' defaultValue={state.newEntityTypeSingularName} onChange={(_,v) => { state.setNewEntityTypeSingularName(v || '') }} />
						</InfoTooltipLabel>
					</StackItem>
					<StackItem>
						<div style={{marginLeft: 10}} >
							<InfoTooltipLabel label='Plural Name' title='This will be the naming convention used throughout the app to refer to multiple instances of this entity type.'>
								<TextField placeholder='e.g. Workspaces' defaultValue={state.newEntityTypePluralName} onChange={(_,v) => { state.setNewEntityTypePluralName(v || '') }} />
							</InfoTooltipLabel>
						</div>
					</StackItem>
				</Stack>

				{ state.newEntityTypeProvisionType !== ProvisionType.NoWorkspace &&
					<InfoTooltipLabel label='Workspace URL field' title='Select the field in your data storage list that will contain the workspace URL when it is provisioned.'>
						<FieldPicker
							key={state.newEntityTypeListUrl} //Reset if the list changes
							config={state.userConfig}
							listUrl={state.newEntityTypeListUrl}
							fieldType={FieldType.Text}
							selectedFieldInternalName={state.newEntityUrlStorageField}
							onFieldPicked={(fieldInternalName) => {
								state.setNewEntityUrlStorageField(fieldInternalName);
							}}
						/>
					</InfoTooltipLabel>
				}

				


			</ReusableDialog>
		</>
	);
}

export default observer(EntityTypeCreateNewDialog);
